<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import * as loginTypes from 'store/modules/login/mutation-types'
import { mapGetters, mapMutations, mapActions } from 'vuex'
const config = require('src/../config/label')

export default {
  name: 'app',
  data: function () {
    return require('src/../config/label')
  },
  computed: {
    pcDisp () {
      return (this.windowWidth >= config.pcWidth)
    },
    ...mapGetters({
      currentUser: loginTypes.GET_CURRENT_USER,
      nowLang: loginTypes.GET_LANG
    })
  },
  created () {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  methods: {
    handleResize () {
      this.windowWidth = document.documentElement.clientWidth
      this.windowHeight = document.documentElement.clientHeight
    },
    focusLang (value) {
      var focus = (value === this.nowLang) ? '_focus' : ''
      return value + focus
    },
    ...mapMutations({
      setLang: loginTypes.SET_LANG,
      setCurrentUser: loginTypes.SET_CURRENT_USER
    }),
    ...mapActions({
      postLogout: loginTypes.POST_LOGOUT
    })
  },
  beforeDestroy () {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style src="assets/scss/style.scss" lang="scss"></style>


// WEBPACK FOOTER //
// App.vue?16b7da00